import { get, post } from './ia-utils';

(function ()
{
    const formats = {
        decimal_percent: function (val)
        {
            var v = val * 100;
            return v + '%';
        },
        percent: function (val)
        {
            return val + '%';
        },
        num: function (val)
        {
            var fm = (d3 ? d3 : Plotly.d3).format(",d");
            return fm(val);
        },
        money: function (val)
        {
            if (d3)
            {
                var fm = d3.format('$,d');
                return fm(val);
            }
            else
            {
                var fm = Plotly.d3.format(",d");
                return "£" + fm(val);
            }
        }
    };

    /*
     * @param options - Object with properties:
     * container - the HTML element to inject this into,
     * type - the chart type
     * labelFormat - the axis label format ('full' or 'date' or 'name'),
     * source - an object with its own properties:
     * url - the URL of the feature layer that provides the data,
     * featureIds - an array of feature IDs,
     * featureIdField - the field that uniquely identifies the features,
     * featureNameField - the field that names the features (optional, defaults to featureIdField),
     * fields - the "raw" names of the columns/fields to use, or, 
     * selector - the alias of the field(s) to use, for more than one use the alias before any | character, 
     * count - if using the "selector" parameter the number of fields to use
     */
    const drawChart = (options) =>
    {
        var outf;
        var featureWhere = options.source.featureIdField + ' IN (\'' + options.source.featureIds.join('\',\'') + '\')';
        options.source.featureNameField = (options.source.featureNameField || options.source.featureIdField);
        if (options.source.fields)
        {
            outf = options.source.featureIdField + ',' + options.source.featureNameField + ',' + (typeof (options.source.fields.splice) != 'undefined' ? options.source.fields.join(',') : options.source.fields);
            return post(options.source.url + '/query', {
                f: 'json',
                outFields: outf,
                where: featureWhere,
                returnGeometry: false
            })
                .then((features) =>
                {
                    return drawChartWithData(options, features);
                });
        }
        else if (options.source.selector)
        {
            return post(options.source.url, {
                f: 'json'
            })
                .then((layerDescriptor) =>
                {
                    outf = [];
                    options.source.selector = (typeof (options.source.selector.splice) != 'undefined' ? options.source.selector : options.source.selector.split(','));
                    for (var i = 0; i < layerDescriptor.fields.length; i++)
                    {
                        for (var j = 0; j < options.source.selector.length; j++)
                        {
                            if (layerDescriptor.fields[i].alias && (layerDescriptor.fields[i].alias.toLowerCase().indexOf(options.source.selector[j].toLowerCase()) == 0))
                            {
                                outf.push(layerDescriptor.fields[i].name);
                            }
                            //else console.log('No match: ' + layerDescriptor.fields[i].alias + ' <> ' + options.source.selector[j]); // DEBUG
                        }
                    }
                    // Slice - presuming latest is last...
                    outf = outf.slice(-1 * Math.min(outf.length, options.source.count));
                    outf.push(options.source.featureIdField);
                    outf.push(options.source.featureNameField);
                    outf = outf.join(',');
                    return post(options.source.url + '/query', {
                        f: 'json',
                        outFields: outf,
                        where: featureWhere,
                        returnGeometry: false
                    })
                        .then((features) =>
                        {
                            return drawChartWithData(options, features);
                        });
                });
        }
    };

    const drawChartWithData = (options, featureData) =>
    {
        const cc = (options.container.jquery ? options.container.get(0) : options.container);
        var data = [];
        var series, value, label, pairs;
        var lblFmt = (options.labelFormat || 'full').toLowerCase();
        // If reasonable, allow indicators as series...
        if (options.seriesType && (options.seriesType.toLowerCase() == 'indicator') && options.source.selector && (options.source.selector.length > 0))
        {
            if (featureData && featureData.features)
            {
                for (var s = 0; s < options.source.selector.length; s++)
                {
                    series = {
                        x: [],
                        y: [],
                        type: (options.type || 'bar'),
                        name: options.source.selector[s]
                    };
                    if (options.fill) series.fill = options.fill;
                    var colLookup = {};
                    for (var j = 0; j < featureData.fields.length; j++)
                    {
                        label = featureData.fields[j].alias;
                        value = featureData.fields[j].name;
                        colLookup[value] = label;
                    }
                    pairs = [];
                    for (var i = 0; i < featureData.features.length; i++)
                    {
                        for (var na in featureData.features[i].attributes)
                        {
                            if ((na != options.source.featureIdField) && (na != options.source.featureNameField) && colLookup[na])
                            {
                                value = featureData.features[i].attributes[na];
                                label = colLookup[na].split('|');
                                if (label.indexOf(options.source.selector[s]) == 0)
                                {
                                    //series.x.push(((lblFmt == 'date') && (label.length > 1) ? label[1] : (lblFmt == 'name' ? featureData.features[i].attributes[options.source.featureNameField] : label.join(' | ') + featureData.features[i].attributes[options.source.featureNameField])));
                                    //series.y.push(value);
                                    pairs.push({
                                        key: ((lblFmt == 'date') && (label.length > 1) ? label[1] : (lblFmt == 'name' ? featureData.features[i].attributes[options.source.featureNameField] : label.join(' | ') + featureData.features[i].attributes[options.source.featureNameField])),
                                        value: value
                                    });
                                }
                            }
                        }
                    }
                    if (options && (lblFmt == 'date') && !options.noSort)
                    {
                        pairs.sort(sortPairsAsc);
                    }
                    for (var j = 0; j < pairs.length; j++)
                    {
                        series.x.push(pairs[j].key);
                        series.y.push(pairs[j].value);
                    }
                    if (options && options.palette)
                    {
                        series.marker = {
                            color: (s < options.palette.length ? options.palette[s] : options.palette[s % options.palette.length])
                        };
                    }
                    data.push(series);
                }
            }
        }
        // Default is feature series bar chart...
        else
        {
            if (featureData && featureData.features)
            {
                var colLookup = {};
                for (var j = 0; j < featureData.fields.length; j++)
                {
                    label = featureData.fields[j].alias;
                    value = featureData.fields[j].name;
                    colLookup[value] = label;
                }
                for (var i = 0; i < featureData.features.length; i++)
                {
                    series = {
                        x: [],
                        y: [],
                        type: (options.type || 'bar'),
                        name: featureData.features[i].attributes[options.source.featureNameField]
                    };
                    if (options.fill) series.fill = options.fill;
                    pairs = [];
                    for (var na in featureData.features[i].attributes)
                    {
                        if ((na != options.source.featureIdField) && (na != options.source.featureNameField) && colLookup[na])
                        {
                            value = featureData.features[i].attributes[na];
                            label = colLookup[na].split('|');
                            //series.x.push(((lblFmt == 'date') && (label.length > 1) ? label[1] : (lblFmt == 'name' ? label[0] : label.join(' | '))));
                            //series.y.push(value);
                            pairs.push({
                                key: ((lblFmt == 'date') && (label.length > 1) ? label[1] : (lblFmt == 'name' ? label[0] : label.join(' | '))),
                                value: value
                            });
                        }
                    }
                    if (options && (lblFmt == 'date') && !options.noSort)
                    {
                        pairs.sort(sortPairsAsc);
                    }
                    for (var j = 0; j < pairs.length; j++)
                    {
                        series.x.push(pairs[j].key);
                        series.y.push(pairs[j].value);
                    }
                    if (options && options.palette)
                    {
                        series.marker = {
                            color: (i < options.palette.length ? options.palette[i] : options.palette[i % options.palette.length])
                        };
                    }
                    data.push(series);
                }
            }
        }
        if (data && (data.length > 0))
        {
            var layout = {
                barmode: 'group',
                margin: {
                    b: 40,
                    l: 60,
                    r: 60,
                    t: 40,
                    pad: 10
                },
                font: {
                    family: (options.fontFamily ? options.fontFamily : 'Roboto'),
                    size: (options.fontSize ? options.fontSize : 12)
                },
                plot_bgcolor: 'rgba(255,255,255,0)',
                paper_bgcolor: 'rgba(255,255,255,0)'
            };
            if (options.layout)
            {
                // Just copy them in - let the caller override
                for (var p in options.layout)
                {
                    layout[p] = options.layout[p];
                }
            }
            var plotOptions = {
                showLink: false,
                displayModeBar: false
            };
            if (options.plot)
            {
                // Just copy them in - let the caller override
                for (var p in options.plot)
                {
                    plotOptions[p] = options.plot[p];
                }
            }
            Plotly.newPlot(cc, data, layout, plotOptions);
            if (!options.fixedSize)
            {
                const c = document.getElementById(options.container);
                window.addEventListener('resize', (e) =>
                {
                    var t = parseInt(c.getAttribute('data-resizeTimeoutId'));
                    clearTimeout(t);
                    t = setTimeout(function ()
                    {
                        Plotly.Plots.resize(c);
                    }, 250);
                    c.setAttribute('data-resizeTimeoutId', t.toFixed(0));
                });
            }
        }
        return document.getElementById(cc);
    };

    const sortPairsAsc = (p1, p2) =>
    {
        return p1.key.localeCompare(p2.key);
    }

    const stat_items = document.querySelectorAll('.tile-stat-chart-container');

    stat_items.forEach((el, i) =>
    {
        var config = JSON.parse(el.getAttribute('data-chart-config')),
            chartId = el.getAttribute('data-chart-id'),
            tile = el.closest('.tile-stat'),
            plot = document.getElementById(chartId),
            format_str = "",
            localeKey = config.locale || document.documentElement.getAttribute('lang') || 'en-US';

        if (localeKey && (localeKey !== 'en-US'))
        {
            const loadAndApply = () =>
            {
                Plotly.setPlotConfig({
                    locale: localeKey
                });
                d3.json('https://unpkg.com/d3-format@1/locale/' + localeKey + '.json', function (error, locale)
                {
                    if (!error)
                    {
                        d3.formatDefaultLocale(locale);
                    }
                });
            };
            if (localeKey.toLowerCase().split('-')[0] !== 'en')
            {
                const tstamp = (new Date()).getTime().toFixed(0);
                window[`callback${tstamp}`] = loadAndApply;
                const stag = document.createElement('script');
                stag.setAttribute('src', 'https://cdn.plot.ly/plotly-locale-' + localeKey.toLowerCase().split('-')[0] + '-latest.js');
                stag.setAttribute('onload', `callback${tstamp}`);
                document.head.appendChild(stag);
            }
            else loadAndApply(); // en seems to be shipped with plotly now and refuses to load in the script, so...
        }

        switch (config.format)
        {
            case "percent":
                format_str = ".2f";
                break;
            case "num":
                format_str = ",.0f";
                break;
            case "decimal_percent":
                format_str = ".2p";
                break;
            case "money":
                format_str = ",.0f";
                break;
            default:
                format_str = "";
        }

        drawChart({
            container: chartId,
            type: config.type,
            fill: 'tozeroy',
            labelFormat: 'date',
            palette: config.palette,
            barmode: config.barmode || "grouped",
            seriesType: config.seriesType || "",
            noSort: (typeof (config.noSort) != 'undefined' ? config.noSort : false),
            layout: {
                font: {
                    family: config.fontFamily || 'Lato, sans-serif',
                    size: config.fontSize || 10,
                    color: config.fontColor || ""
                },
                margin: {
                    t: 10, r: 40, l: 60, b: 25
                },
                xaxis: {
                    showgrid: false,
                    showticklabels: false,
                    fixedrange: true,
                    hoverformat: config.xformat || "",
                },
                yaxis: {
                    showgrid: false,
                    showticklabels: true,
                    hovermode: "closest",
                    hoverformat: format_str,
                    fixedrange: true,
                    type: 'log'
                }
            },

            source: config.source
        })
            .then((plotElement) =>
            {
                const afterRender = () =>
                {
                    var data = plotElement.data;
                    var labelIndex = Math.min(data[0].x.length - 1, data[0].y.length - 1);
                    if (config && config.labelDate)
                    {
                        for (var i = 0; i <= labelIndex; i++)
                        {
                            if (data[0].x[i].toString().toLowerCase() === config.labelDate.toLowerCase())
                            {
                                labelIndex = i;
                                break;
                            }
                        }
                    }
                    var latest_value = data[0].y[labelIndex];
                    var latest_date = data[0].x[labelIndex];

                    /**
                     * Round all floats 3 dec places
                     */
                    if (latest_value && latest_value % 1 !== 0)
                    {
                        latest_value = parseFloat(latest_value.toFixed(2));
                    }

                    const formatter = Plotly.d3.format(config.yformat || "");
                    let value_formatted = (config.format ? formats[config.format](latest_value) : latest_value);

                    tile.querySelector('.stat-value').innerText = value_formatted;
                    tile.querySelector('.stat-label').innerText = latest_date;

                    const tableTag = document.createElement('table');
                    tableTag.setAttribute('class', 'stat-table screen-reader-only');
                    let tablePart = document.createElement('thead'),
                        tableRow = document.createElement('tr'),
                        tableCell;
                    if (config.type == 'timeseries')
                    {
                        tableCell = document.createElement('th');
                        tableCell.setAttribute('colspan', '2');
                        tableCell.appendChild(document.createTextNode(config.title));
                        tableRow.appendChild(tableCell);
                        tablePart.appendChild(tableRow);
                        tableRow = document.createElement('tr');
                        tableCell = document.createElement('th');
                        tableCell.appendChild(document.createTextNode('Date'));
                        tableRow.appendChild(tableCell);
                        tableCell = document.createElement('th');
                        tableCell.appendChild(document.createTextNode(data[0].name));
                        tableRow.appendChild(tableCell);
                        tablePart.appendChild(tableRow);
                        tableTag.appendChild(tablePart);
                        tablePart = document.createElement('tbody');
                        for (var i = 0; i < data[0].x.length; i++)
                        {
                            value_formatted = (config.format ? formats[config.format](data[0].y[i]) : data[0].y[i]);
                            tableRow = document.createElement('tr');
                            tableCell = document.createElement('td');
                            tableCell.appendChild(document.createTextNode(data[0].x[i]));
                            tableRow.appendChild(tableCell);
                            tableCell = document.createElement('td');
                            tableCell.appendChild(document.createTextNode(value_formatted));
                            tableRow.appendChild(tableCell);
                            tablePart.appendChild(tableRow);
                        }
                        tableTag.appendChild(tablePart);
                        el.appendChild(tableTag);
                    }
                    const esvg = el.querySelector('svg');
                    esvg.setAttribute('role', 'img');
                    esvg.setAttribute('aria-label', config.title);
                    esvg.setAttribute('focusable', 'false');
                    /**
                     * Set the chart to loaded
                     * Emit tile load event
                     */
                    tile.setAttribute('class', tile.getAttribute('class').replace(/tile-loading/g, ''));
                };
                if (plotElement.data !== undefined) afterRender();
                else plotElement.on('plotly_afterplot', afterRender);
            });
    });

})();
